function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHappy = function SvgHappy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__happy",
    d: "M12.5 8A12.5 12.5 0 1 0 25 20.5 12.5 12.5 0 0 0 12.5 8zm0 22.581A10.081 10.081 0 1 1 22.581 20.5 10.091 10.091 0 0 1 12.5 30.581zM8.468 19.694a1.613 1.613 0 1 0-1.613-1.613 1.611 1.611 0 0 0 1.613 1.613zm8.065 0a1.613 1.613 0 1 0-1.613-1.613 1.611 1.611 0 0 0 1.612 1.613zm.2 3.659a5.506 5.506 0 0 1-8.468 0A1.21 1.21 0 1 0 6.406 24.9a7.935 7.935 0 0 0 12.187 0 1.21 1.21 0 1 0-1.86-1.547z",
    transform: "translate(0 -8)",
    style: {
      fill: "#fff"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHappy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/happy.58f0ceac.svg";
export { ForwardRef as ReactComponent };